// extracted by mini-css-extract-plugin
module.exports = {"root":"Tooltip_root__Ue7Ha","tooltip":"Tooltip_tooltip__prgdU","title":"Tooltip_title__mM6n9","content":"Tooltip_content__dwiYX"};